export default "__VITE_ASSET__B4M40Sw4__"